<template>
  <div class="position-site-wrap" @click.stop>
    <!--定位方式-->
    <div class="position-select-set">
      <div class="position-select verticallyCenter" @click="openPositionSelects">
        <span :class="'icon ' + activePositon.icon"></span>
        <span class="flex1">{{ activePositon.title }}</span>
        <span class="icon icon-portal-arrows-down text-right" :class="showPositionStyle ? 'rotate180' : ''"></span>
      </div>
      <div class="position-selects-wrap" v-show="showPositionStyle">
        <ul class="position-selects">
          <li
            v-for="(item, index) in positionList"
            class="position-select-item verticallyCenter"
            :key="index"
            @mouseenter="positionSelectHover(item)"
            @click.stop="selectPositionStyle(item)"
            @mouseleave="showPositonInfo = false"
          >
            <span :class="'icon ' + item.icon"></span>
            <span>{{ item.title }}</span>
          </li>
        </ul>
      </div>
    </div>
    <!--快捷定位-->
    <div class="mt8" v-if="positionTypeVal && positionTypeVal !== 'relative'">
      <ul v-if="positionTypeVal !== 'sticky'" class="mb8 verticallyCenter quick-sites-wrap">
        <li v-for="(site, index) in defaultSite" :key="index" class="quick-sites"   :class="siteTypeVal === site.typeId ?'active':''" @click="changeQuickSite(site)">
          <el-tooltip class="item" :hide-after="1000"  effect="dark" :content="site.label" placement="top">
            <span class="quick-sites-item">
              <span class="quick-sites-dot" :style="getSiteStyle(site)"></span>
            </span>
          </el-tooltip>
        </li>
      </ul>
      <svg width="228" height="80" viewBox="0 0 228 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          @click="changeSite('bottomVal', -10)"
          d="M4 80H224C224.919 80 225.766 79.6904 226.441 79.1689L168 48H60L1.55859 79.1689C2.23413 79.6904 3.08081 80 4 80Z"
          fill="#F0F0F0"
        />
        <text class="svg-text" x="105" y="70" fill="rgba(0, 0, 0, 0.8)">
          {{getShowVal('bottomVal')}}
        </text>
        <path
          @click="changeSite('rightVal', 15)"
          d="M228 76V4C228 2.70996 227.389 1.5625 226.441 0.831055L168 32V48L226.441 79.1689C227.389 78.4375 228 77.29 228 76Z"
          fill="#EAEAEA"
        />
        <text class="svg-text" x="185" y="45" fill="rgba(0, 0, 0, 0.8)">
          {{getShowVal('rightVal')}}
        </text>
        <path
          @click="changeSite('topVal', 30)"
          d="M226.441 0.831055L168 32H60L1.55859 0.831055C2.23413 0.30957 3.08081 0 4 0H224C224.919 0 225.766 0.30957 226.441 0.831055Z"
          fill="#F0F0F0"
        />
        <text class="svg-text" x="105" y="20" fill="rgba(0, 0, 0, 0.8)">
          {{getShowVal('topVal')}}
        </text>
        <path
          @click="changeSite('leftVal', 15)"
          d="M1.55859 0.831055L60 32V48L1.55859 79.1689C0.610596 78.4375 0 77.29 0 76V4C0 2.70996 0.610596 1.5625 1.55859 0.831055Z"
          fill="#EAEAEA"
        />
        <text class="svg-text" x="15" y="45" fill="rgba(0, 0, 0, 0.8)">
          {{getShowVal('leftVal')}}
        </text>
      </svg>
      <div class="site-settings" v-show="showSiteSetting" :style="'margin-top:' + marginTop">
        <!-- 旧数据用旧模式-->
        <slider-and-input v-if="!siteTypeVal" class="mb6" :value.sync="inputNum" titlePosition="allInOneLine" suffix="%" />
        <slider-and-input v-else class="mb6" :value.sync="inputNum1" :sliderMax="2000" titlePosition="allInOneLine" suffix="px" />
        <div class="verticallyCenter site-selects">
          <div class="item">
            <div class="site-select w56" @click="changeSiteNum('auto')">自动</div>
          </div>
          <div class="flex1 verticallyCenter site-nums">
            <div class="site-select" v-for="item in defaultPos" @click="changeSiteNum(item)">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 层叠顺序设置 -->
    <div class="verticallyCenter" v-if="positionTypeVal && positionTypeVal !== 'relative'">
      <span class="fs14 mr16">层叠顺序</span>
      <div class="row-set flex1">
        <div class="verticallyCenter el-input">
          <single-input
            class="mr8"
            style="width: 104px; flex: 1"
            :value.sync="zIndexVal"
            :noInputSuffixs="true"
            :min="minZIndex"
            :max="maxZIndex"
            :noInputHandle="true"
          />
          <div class="btn-wrapper">
              <span
                :class="zIndexVal === minZIndex ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                @click="changeZindex(0)"
              ></span>
            <span
              :class="zIndexVal === maxZIndex ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
              @click="changeZindex(1)"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "position-set",
  props: {
    left: {
      type: String,
      default: "自动"
    },
    right: {
      type: String,
      default: "自动"
    },
    top: {
      type: String,
      default: "自动"
    },
    bottom: {
      type: String,
      default: "自动"
    },
    positionType: {
      type: String,
      default: "relative"
    },
    ids: {
      type: Object,
      required: true
    },
    inDocument: {
      type: String,
      default: "none"
    },
    positionSiteType:{
      type:Number
    },
    pxOffset:{
      type: null
    },
    zIndex:{
      type:Number,
      default:0
    }
  },
  computed: {
    siteTypeVal:{
      get() {
        return this.positionSiteType
      },
      set(newVal) {
        this.$emit("update:positionSiteType", newVal)
      }
    },
    pxOffsetVal:{
      get(){
        if(this.pxOffset){
          return this.pxOffset
        }else{
          return ['自动','自动','自动','自动']
        }
      },
      set(newVal){
        this.$emit("update:pxOffset", newVal)
      }
    },
    leftVal: {
      get() {
        return this.left
      },
      set(newVal) {
        this.$emit("update:left", newVal)
      }
    },
    rightVal: {
      get() {
        return this.right
      },
      set(newVal) {
        this.$emit("update:right", newVal)
      }
    },
    topVal: {
      get() {
        return this.top
      },
      set(newVal) {
        this.$emit("update:top", newVal)
      }
    },
    bottomVal: {
      get() {
        return this.bottom
      },
      set(newVal) {
        this.$emit("update:bottom", newVal)
      }
    },
    translateVal: {
      get() {
        return this.translate
      },
      set(newVal) {
        this.$emit("update:translate", newVal)
      }
    },
    positionTypeVal: {
      get() {
        return this.positionType
      },
      set(newVal) {
        this.$emit("update:positionType", newVal)
      }
    },
    getSiteStyle() {
      return function (item) {
        return {
          left: item.left,
          right: item.right,
          top: item.top,
          bottom: item.bottom,
          transform: `translate${item.translate}`
        }
      }
    },
    positionList(){
      let fixedSet= []
      let pageLayoutIndex = this.ids.pageLayoutId;
      // 布局不展示固定定位
      if(pageLayoutIndex.toString().indexOf("_") === -1) {
        fixedSet = [
          {
            icon: "icon-fixed icon-img",
            value: "fixed",
            title: "固定定位",
            info: "相对于浏览器窗口进行定位，可以使用 上、右、下、左 这 4 个属性来定义元素相对于浏览器窗口的位置。使用固定定位的元素无论如何滚动浏览器窗口，元素的位置都是固定不变的。"
          }
        ]
      } else {
        // fixedSet = [
        //   {
        //     icon: "icon-sticky icon-img",
        //     value: "sticky",
        //     title: "粘性定位",
        //     info: "相对于浏览器窗口进行定位。"
        //   }
        // ]
      }
      let defaultSet =   [
        {
          icon: "icon-portal-close",
          value: "relative",
          title: "无定位",
          info: "使用正常的布局行为。"
        },
        {
          icon: "icon-absolute icon-img",
          value: "absolute",
          title: "绝对定位",
          info: "相对于最近的一个定位的父级元素进行定位，可以通过 上、右、下、左 这 4 个属性来设置元素相对于父级元素位置的偏移量。如果没有满足条件的父级元素，则会相对于浏览器窗口来进行定位。使用绝对定位的元素不会对其它元素造成影响。"
        }
      ]
      return  defaultSet.concat(fixedSet)
    },
    originInputValue:{
      get(){
        if(this.valueType === 'px'){
          return this.inputNum1
        }else{
          return this.inputNum
        }
      },
      set(newVal){
        if(this.valueType === 'px'){
          this.inputNum1 = newVal
        }else{
          this.inputNum = newVal
        }
      }
    },
    zIndexVal:{
      get(){
        return this.zIndex
      },
      set(newVal){
        this.$emit("update:zIndex", newVal)
      }
    }
  },
  watch: {
    inputNum(newVal) {
      this.inputNumChange(newVal,'inputNum')
    },
    inputNum1(newVal){
      this.inputNum1Change(newVal,'inputNum1')
    },
    "ids.pageLayoutId": {
      deep: true,
      handler(newVal) {
        this.closeDialog()
        this.getInitPosition()
      }
    },
    positionTypeVal: {
      deep: true,
      handler(newVal) {
        this.getInitPosition()
      }
    }
  },
  data() {
    return {
      inputNum: 0,
      inputNum1: 0 ,
      valueType:'px',
      showSiteSetting: false,
      marginTop: 0,
      activeDirection: "",
      activePositon: {},
      defaultPos: [0, 10, 20, 40, 50, 60, 80, 100],
      activePositonInfo: "",
      showPositionStyle: false,
      showPositonInfo: false,
      defaultSite: [
        {
          typeId:1,
          label: "顶部居左",
          top: "0%",
          left: "0%"
        },
        {
          typeId:2,
          label: "顶部居中",
          top: "0%",
          left: "50%",
          translate: "(-50%,0)"
        },
        {
          typeId:3,
          label: "顶部居右",
          top: "0%",
          right: "0%"
        },
        {
          typeId:4,
          label: "右侧居中",
          top: "50%",
          right: "0%",
          translate: "(0,-50%)"
        },
        {
          typeId:5,
          label: "底部居右",
          bottom: "0%",
          right: "0%"
        },
        {
          typeId:6,
          label: "底部居中",
          left: "50%",
          bottom: "0%",
          translate: "(-50%,0)"
        },
        {
          typeId:7,
          label: "底部居左",
          left: "0%",
          bottom: "0%"
        },
        {
          typeId:8,
          label: "左侧居中",
          left: "0%",
          top: "50%",
          translate: "(0,-50%)"
        },
        {
          typeId:9,
          label: "中心",
          left: "50%",
          top: "50%",
          translate: "(-50%,-50%)"
        }
      ],
      maxZIndex: 9999,
      minZIndex:0
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.closeDialog()
      this.getInitPosition()
    })
  },
  beforeDestroy() {
    document.getElementsByClassName("right-toolbar")[0]?.removeEventListener("click", this.closeSiteSetting)
    document.getElementsByClassName("edit_stage")[0]?.removeEventListener("click", this.closeSiteSetting)
  },
  methods: {
    getShowVal(type){
      if(!this.siteTypeVal){
        // 旧数据
        return this[type] === 'auto'?'自动': this[type]
      }else{
        let val
        switch(type){
          case "topVal":
            val = this.pxOffsetVal[0]
            break
          case "rightVal":
            val = this.pxOffsetVal[1]
            break
          case "bottomVal":
            val = this.pxOffsetVal[2]
            break
          case "leftVal":
            val = this.pxOffsetVal[3]
            break
          default:
        }
        return val === '自动'? val:val+'px'
      }
    },
    getInitPosition() {
      for (let i = 0; i < this.positionList.length; i++) {
        if (this.positionType === this.positionList[i].value) {
          this.activePositon = this.positionList[i]
          this.activePositonInfo = this.activePositon.info
          break
        }
      }
    },
    openPositionSelects() {
      if (this.inDocument === 'anchor') return
      this.showPositionStyle = true
    },
    positionSelectHover(item) {
      this.activePositonInfo = item.info
      this.showPositonInfo = true
    },
    selectPositionStyle(item) {
      this.activePositon = item
      this.positionTypeVal = item.value
      this.showPositionStyle = false
      this.translateVal = null
      this.topVal = "0%"
      this.leftVal = "0%"
      this.rightVal = "auto"
      this.bottomVal = "auto"
      this.inputNum1 = 0
      this.siteTypeVal = 1
      this.pxOffsetVal = ['自动','自动','自动','自动']
    },
    changeSite(name, marginTop) {
      this.inputNum = parseInt(this[name])
      let offset = JSON.parse(JSON.stringify(this.pxOffsetVal))
      if(this.positionTypeVal === "sticky" && name !== "topVal") {
        return
      }
      switch(name){
        case "topVal":
          if(offset[0] === '自动'){
            offset[0] = 0
            offset[2] = '自动'
            this.inputNum1 = this.pxOffsetVal[0] === '自动'? 0 : this.pxOffsetVal[0]
          } else {
            this.inputNum1 = offset[0]
          }
          break
        case "rightVal":
          if(offset[1] === '自动'){
            offset[1] = 0
            offset[3] = '自动'
            this.inputNum1 = this.pxOffsetVal[1] === '自动'? 0 : this.pxOffsetVal[1]
          } else {
            this.inputNum1 = offset[1]
          }
          break
        case "bottomVal":
          if(offset[2] === '自动'){
            offset[2] = 0
            offset[0] = '自动'
            this.inputNum1 = this.pxOffsetVal[2] === '自动'? 0 : this.pxOffsetVal[2]
          } else {
            this.inputNum1 = offset[2]
          }
          break
        case "leftVal":
          if(offset[3] === '自动'){
            offset[3] = 0
            offset[1] = '自动'
            this.inputNum1 = this.pxOffsetVal[3] === '自动'? 0 : this.pxOffsetVal[3]
          } else {
            this.inputNum1 = offset[3]
          }
          break
        default:
      }
      this.$set(this,'pxOffsetVal',offset)
      this.marginTop = -marginTop + "px"
      this.showSiteSetting = true
      this.activeDirection = name
    },
    changeSiteNum(newVal) {
      // 旧模式-- 使用%
      // this.inputNum = newVal
      // 新模式 --- 使用px
      this.inputNum1 = newVal
      const curSite = this.defaultSite.find(item=>item.typeId === this.siteTypeVal)
      if(curSite){
        this.topVal = curSite.top
        this.leftVal = curSite.left
        this.rightVal = curSite.right
        this.bottomVal = curSite.bottom
      }
    },
    // 点击其他区域 关闭弹框
    closeDialog() {
      document.getElementsByClassName("right-toolbar")[0]?.addEventListener("click", this.closeSiteSetting)
      document.getElementsByClassName("edit_stage")[0]?.addEventListener("click", this.closeSiteSetting)

    },
    closeSiteSetting() {
      this.showSiteSetting = false
      this.showPositionStyle = false
    },
    // 选择快捷位置
    changeQuickSite(site) {
      this.leftVal = typeof site.left === "undefined" ? "auto" : site.left
      this.rightVal = typeof site.right === "undefined" ? "auto" : site.right
      this.bottomVal = typeof site.bottom === "undefined" ? "auto" : site.bottom
      this.topVal = typeof site.top === "undefined" ? "auto" : site.top
      this.translateVal = typeof site.translate === "undefined" ? null : site.translate
      this.siteTypeVal = site.typeId
      this.pxOffsetVal = ['自动','自动','自动','自动']
    },
    inputNumChange(newVal) {
        let val = newVal === "auto" || newVal === "自动" || isNaN(newVal) ? "自动" : newVal + "%"
        this.$set(this, this.activeDirection, val)
        if (val === "自动") {
          return
        }
        switch (this.activeDirection) {
          case "leftVal":
            this.rightVal = "自动"
            break
          case "rightVal":
            this.leftVal = "自动"
            break
          case "topVal":
            this.bottomVal = "自动"
            break
          case "bottomVal":
            this.topVal = "自动"
            break
        }
    },
    inputNum1Change(newVal) {
        let val = newVal === "auto" || newVal === "自动" || isNaN(newVal) ? "自动" : newVal
        let offset = JSON.parse(JSON.stringify(this.pxOffsetVal))
        switch (this.activeDirection) {
          case "topVal":
            offset[0] = val
            offset[2] = '自动'
            break
          case "rightVal":
            offset[1] = val
            offset[3] = '自动'
            break
          case "bottomVal":
            offset[2] = val
            offset[0] = '自动'
            break
          case "leftVal":
            offset[3] = val
            offset[1] = '自动'
            break
        }
        this.$set(this, 'pxOffsetVal',offset)
    },
    changeZindex(flag){
      if(flag === 0){
        this.zIndexVal = this.zIndexVal > this.minZIndex ? this.zIndexVal-1 : this.zIndexVal
      }else{
        this.zIndexVal = this.zIndexVal< this.maxZIndex ? this.zIndexVal+1 : this.zIndexVal
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.position-site-wrap {
  position: relative;
  overflow: visible;
  z-index: 999;
}
path {
  cursor: pointer;
}
path:hover {
  fill: #e3e3e3;
}
.svg-text {
  pointer-events: none;
  cursor: pointer;
  user-select: none;
}
.w56 {
  width: 56px;
  height: 56px;
  line-height: 56px;
}
.site-selects {
  user-select: none;
}
.site-selects .item {
  margin: 0 2px;
}
.site-selects .item:first-child {
  margin-left: 0;
}
.site-selects .item:last-child {
  margin-right: 0;
}
.site-select {
  background: #f3f3f3;
  border-radius: 4px;
  margin: 2px 0;
  text-align: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.8);
  &:hover {
    background-color: #ebebeb;
  }
  &:active {
    background-color: rgba(0, 0, 0, 0.12);
  }
}
.site-settings {
  position: absolute;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  z-index: 2;
  border: 1px solid #e9e9e9;
  background-color: #fff;
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
}
.mb6 {
  margin-bottom: 6px;
}
.site-nums {
  flex-wrap: wrap;
  justify-content: space-around;
}
.site-nums .site-select {
  width: calc(25% - 4px);
  height: 26px;
}
.quick-sites-wrap {
  justify-content: space-between;
}
.quick-sites {
  border-radius: 2px;
  width: 20px;
  height: 20px;
  text-align: center;
  &:hover {
    background: rgba(31, 35, 41, 0.08);
  }
  &:active {
    background: rgba(0, 0, 0, 0.12);
  }
  &.active{
    .quick-sites-item{
      border:1px solid var(--themeColor);
    }
    .quick-sites-dot{
      background: var(--themeColor);
    }
  }
}
.quick-sites-item {
  position: relative;
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 1px;
  .quick-sites-dot {
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 1px;
    display: inline-block;
    width: 6px;
    height: 6px;
    content: "";
  }
}
.position-select {
  background: #f3f3f3;
  border-radius: 4px;
  height: 32px;
  padding: 0 13px;
  box-sizing: border-box;
  cursor: pointer;
  .icon {
    margin-right: 9px;
    pointer-events: none;
    transition: transform 0.3s;
    transform-origin: center center;
    &.rotate180 {
      transform: rotate(180deg);
    }
  }
  .text-right {
    font-size: 16px;
    width: 16px;
    text-align: right;
  }
}
.position-selects-wrap {
  width: 228px;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  border: 1px solid #dee0e3;
  padding: 4px 0;
  z-index: 9999;
  background-color: #fff;
  .position-select-item {
    padding: 0 12px;
    height: 38px;
    line-height: 38px;
    box-sizing: border-box;
    width: 100%;
    cursor: pointer;
    .icon {
      margin-right: 9px;
    }
    &:hover {
      background-color: #f0f2f7;
    }
  }
}
.icon-img {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
}
.icon-img.icon-absolute {
  background-image: url("../../../assets/images/absolute.png");
}
.icon-img.icon-fixed {
  background-image: url("../../../assets/images/fixed.png");
}
.icon-img.icon-sticky {
  background-image: url("../../../assets/images/sticky.png");
}
.position-info {
  position: relative;
  padding: 12px 12px 12px 24px;
  box-sizing: border-box;
  border-top: 1px solid #e8e8e8;
  &:before {
    position: absolute;
    top: 12px;
    bottom: 12px;
    left: 11px;
    width: 2px;
    content: "";
    background-color: rgba(43, 103, 255, 0.5);
  }
}
.position-select-set {
  position: relative;
}
.position-select-dropdown {
  width: 100%;
}
.btn-wrapper {
  background-color: var(--inputBg);
  border-radius: 4px;
  padding: 6px 0;
  font-size: 0;
  flex: 1;
  .num-btn {
    display: inline-block;
    width: 50%;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    cursor: pointer;
    &:not(:last-child) {
      border-right: 1px solid var(--sliderBackGround);
    }
    &:not(.disabled):hover {
      color: var(--themeColor);
    }
    &.disabled {
      color: var(--borderColorSeven);
      cursor: not-allowed;
    }
  }
}
</style>
